<div class="flex flex-row flex-wrap content-start gap-6">
  @for(card of selectedCards; track $index)
    {
    <div
      class="dash"
      [id]="card.thingieIds[0]"
      #thingieCards
      >
      <!-- show skeleton cards while the cards load -->
      @if (card.isLoading) {
        <mat-card>
          <mat-card-header>
            <ion-skeleton-text animated="true" class="skeleton-block-top"></ion-skeleton-text>
            <ion-skeleton-text animated="true" class="skeleton-block-bottom"></ion-skeleton-text>
          </mat-card-header>
        </mat-card>
      }
      @if (card.isStack && !card.isSingle && !card.isLoading) {
        <mat-card class="matcard-inside mat-elevation-z4 fake first"></mat-card>
      }
      @if (!card.isLoading) {
        <mat-card class="matcard-inside mat-elevation-z4 real">
          <mat-card-header class="!mt-0.5">
            <ng-container>
            @if ((card.thingie$ | async); as thingie) {
              <div class="card-header">
                  <a
                    [routerLink]="card.isStack
                      ? [urls.route.dashboardStackDetail(card.thingieIds[0])]
                      : [urls.route.thingieDetail(thingie._id!)]
                    "
                    (click)="_thingieLinkClicked(card)"
                    [queryParams]="stackQueryParams"
                    class="card-title mr-auto !leading-5"
                    [ngClass]="{'stack-card': card.isStack , 'w-full': !card.isStack}"
                    role="link"
                    [matTooltip]="thingie.baseName"
                    data-cy="thingie_card_list__card_header_link"
                  >
                    <ng-container *ngTemplateOutlet="
                      cardNameTemplate;
                      context: {
                        name: card.isStack ? thingie.baseName : (thingie | replicateFullname),
                      }
                      "
                    >
                  </ng-container>
                  <ng-template #cardNameTemplate let-name="name">
                    <app-string-ellipsis [input]="name" [lines]="2" />
                  </ng-template>
                </a>
                @let warning = card.previewTab._extraData.calibrationWarning;
                @if (warning) {
                  <button
                    mat-icon-button
                    class="!cursor-help"
                    [matTooltip]="warning ?? ''"
                    ><ion-icon name="information-circle-outline" class="text-alertYellow-60"></ion-icon>
                  </button>
                }
                @if (card.isStack) {
                  <button
                    mat-icon-button
                    #t="matMenuTrigger"
                    [ngClass]="{'menuOpen': t.menuOpen}"
                    [matMenuTriggerFor]="replicatesMenu"
                    class="replicateBox mr-[-8px] ml-[1px]"
                    [matTooltip]="card.thingieIds.length + ' replicates in experiment. Select to view replicate details.'"
                    data-cy="thingie_card_list__card_replicates_menu_trigger"
                    >
                    <ion-icon name="chevron-down" />
                  </button>
                }
                <mat-menu #replicatesMenu xPosition="before">
                  @for(thingie of ((card.thingieIds | pureFnCall:getThingiesByIds | async | pureFnCall:sortThingiesByName) ?? []); track $index; let i = $index)
                    {
                    <button
                      mat-menu-item
                      (click)="routeToReplicate(urls.route.thingieDetail(thingie._id!))"
                      class="max-w-lg"
                    >
                      <app-string-ellipsis [input]="thingie.name" />
                    </button>
                  }
                </mat-menu>
                <div class="state-bar">
                  @if ((card.thingieIds | pureFnCall:getThingiesByIds | async); as thingies) {
                    <app-thingie-state-chip
                      class="error-icon-bg-white"
                      [thingies]="thingies"
                    ></app-thingie-state-chip>
                  }
                  @if (card.isPinned) {
                    <button
                      class="pin-chip color-pinned"
                      [matTooltip]="'Unpin replicate'"
                      (click)="removePinnedCard(thingie._id!, card)">
                      Pinned
                    </button>
                  }
                  @if (!card.isPinned) {
                    <button
                      class="pin-chip color-pin"
                      [matTooltip]="'Pin replicate to the top of the dashboard'"
                      (click)="addPinnedCard(thingie._id!, card)">
                      Pin card
                    </button>
                  }
                </div>
              </div>
            }
          </ng-container>
        </mat-card-header>
        @if ((card.thingie$ | async); as thingie) {
          <mat-card-content class="mat-mdc-card-content">
            <app-card-plotly
              [id]="idPrefix + '-' + $index"
              [card]="card"
              (plotNextPlot)="plotNextPlot()" />
          </mat-card-content>
        }
      </mat-card>
    }
  </div>
}
</div>
